import PedidoInfo from './PedidoInfo';

export default PedidoInfo;